import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import { push } from 'connected-next-router';
import type { Dispatch } from 'redux';

import { Favourites } from '../components/Favourites';
import { actions as favouritesActions } from '../redux/slice';
import type { FavouritesSummary, StateWithFavourites } from '../types/favourites';

const mapStateToProps = (state: StateWithFavourites) => ({
  isModalOpen: state.favourites.isModalOpen,
  selectedProductCodeForModal: state.favourites.selectedProductCodeForModal,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onCloseModal: () => dispatch(favouritesActions.closeModal()),
  setFavouritesSummary: (summary: FavouritesSummary) =>
    dispatch(favouritesActions.setFavouritesSummary(summary)),
  redirectToUserFavourites: () => dispatch(push({ pathname: '/u/favourites' })),
});

const connector = connect(mapStateToProps, mapDispatchToProps);

export type FavouritesContainerProps = ConnectedProps<typeof connector>;

export const FavouritesContainer = connector(Favourites);
